import React from 'react';
import { Route } from 'react-router';

import Home from '../../components/Pages/Home';


const routes = <Route path="home" component={Home.LandingPage} />;

export default routes;



// WEBPACK FOOTER //
// ./src/routes/www/home.js